module.exports = __webpack_public_path__ + "img/1590238137.27fb2831.jpg";